import { OPEN_RESOURCE_EDIT_MODAL, CLOSE_RESOURCE_EDIT_MODAL } from 'js/constants/actionTypes';

export const openResourceEditModal = () => ({
  type: OPEN_RESOURCE_EDIT_MODAL,
});

export const closeResourceEditModal = () => ({
  type: CLOSE_RESOURCE_EDIT_MODAL,
});
